var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.197,
    height: 8.194,
    viewBox: "0 0 9.197 8.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-svgrepo-com",
    d: "M6.209,5.821h8.2m-8.2,3.6h8.2m-8.2,3.6h8.2",
    transform: "translate(-5.709 -5.321)",
    fill: "none",
    stroke: "#adb7ca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelList);
export default __webpack_public_path__ + "static/media/channel-list.dd34a690d2dd50a97824218563acfa4b.svg";
export { ForwardRef as ReactComponent };